import { type FunctionComponent, useState } from 'react';
import { Link, Stub, Text, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { isFunction } from '@direct-frontend/stdlib';
import { pluralize } from '#shared/lib/string';
import { useCategoriesChain } from '../../hooks/useCategoriesChain';

export interface CategoriesChainProps extends TestProps {
    ids: string[];
}

export const CategoriesChain: FunctionComponent<CategoriesChainProps> = ({
    'data-testid': dataTestId = 'CategoriesChain',
    ids,
}) => {
    const { isFetching, data, isError, isSuccess, refetch } = useCategoriesChain(ids);

    const categoriesShowedCountDefault = 3;
    const [categoriesShowedCount, setCategoriesShowedCount] = useState(categoriesShowedCountDefault);

    if (isFetching || isError || !isSuccess) {
        setTimeout(() => {
            isFunction(refetch) && refetch();
        }, 1000);

        return (
            <VStack gap="4">
                {ids.slice(0, categoriesShowedCount).map((_, index) => (
                    <Stub key={index} height={20} width={100} />
                ))}
            </VStack>
        );
    }

    return (
        <VStack data-testid={dataTestId} gap="8">
            {data.slice(0, categoriesShowedCount).map((chain, index) => (
                <Text key={index} size="s" maxLines={2}>
                    {chain
                        .map((item) => {
                            if (typeof item === 'string') {
                                return item;
                            }

                            return item.title;
                        })
                        .join('\u00a0→ ')}
                </Text>
            ))}
            {data.length > categoriesShowedCount && (
                <Text role="supplementary" size="xs">
                    <Link onClick={() => setCategoriesShowedCount(Number.MAX_SAFE_INTEGER)} color="supplementary">
                        Показать {pluralize(data.length, `всю %d категорию`, `все %d категории`, `все %d категорий`)}
                    </Link>
                </Text>
            )}
        </VStack>
    );
};
